import { useRef } from 'react';
import Product from 'src/modules/parkplusStoreV2/types/product';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { Typography } from 'ui-v2/components/Typography';
import VideoCard from '../VideoCard';
import s from './VideoCarouselCard.module.scss';
interface VideoCarouselCardProp {
  isActive: number;
  showControls: boolean;
  idx?: number;
  id?: string;
  onVideoEnd?: () => void;
  data: Product;
}

const VideoCarouselCard = ({
  isActive,
  showControls,
  idx,
  id,
  onVideoEnd,
  data,
}: VideoCarouselCardProp) => {
  const cardRef = useRef();
  return (
    <div className={s.root}>
      <div className={s.card} ref={cardRef} data-index={idx} id={id}>
        <VideoCard
          customStyle={{
            width: 'calc(100%)',
            height: '350px',
          }}
          url={data?.videoUrl}
          thumbnailUrl={data?.coverImage}
          showControls={showControls}
          isActive={isActive === idx}
          key={isActive === idx ? `${idx}_active` : `${idx}_inActive`}
          onVideoEnd={onVideoEnd}
        />
      </div>

      {/* <div className={s.cardContent}>
        <div className={s.icon}>
          <AnimatedImage src={data?.brandLogo} alt="brandLogo" />
        </div>

        <Typography label={data?.offerText} variant="h_3_medium" color="alert" />
      </div> */}
    </div>
  );
};

export default VideoCarouselCard;
